import { Slider, SliderThumb, SliderMarkLabel, SliderMark } from "@mui/material";
import { useEffect, useState } from "react";
import styled from "styled-components";
import IconFace2 from "../../../assets/images/icon-face-2.svg"
import IconFace3 from "../../../assets/images/icon-face-3.svg"
import IconFace5 from "../../../assets/images/icon-face-5.svg"

const Container = styled.div`
    width: 100%;
    height: 60px;
    margin-top: 16px;
`;

const SliderBox = styled(Slider)(() => ({
    width: "calc(100% - 60px) !important",
    height: 4,
    color: '#FFFFFF00 !important',
    '& .MuiSlider-thumb': {
        height: 32,
        width: 32,
        backgroundColor: '#FFFFFF',
        border: '0px',
        '&:hover': {
            boxShadow: '0 0 0 8px rgba(248,244,218,0.6)',
        },
    },
    '& .MuiSlider-track': {
        color: "#FFFFFF00",
        height: 0,
    },
    '& .MuiSlider-rail': {
        backgroundImage: "linear-gradient(90deg, rgba(143,236,234,1) 0%, rgba(251,226,80,1) 100%)",
        opacity: 1,
        height: 6,
    },
    '& .MuiSlider-mark': {
        height: 10,
        width: 10,
        borderRadius: "50%",
        backgroundColor: '#8FECEA',
    },
}));

function ThumbComponent(props, value) {
    const { children, ...other } = props;
    return (
        <SliderThumb {...other}>
            {children}
            {[0, 1, 2, 3, 4, 5, 6].includes(value) && <img src={IconFace2} />}
            {[7, 8].includes(value) && <img src={IconFace3} />}
            {[9, 10].includes(value) && <img src={IconFace5} />}
        </SliderThumb>
    );
}

function MarkComponent(props) {
    const { children, ...other } = props;
    return (
        <SliderMark {...other}>
        </SliderMark>
    );
}

function Rating10Component({
    value,
    disable,
    labelError,
    isError,
    onSelect,
}) {
    const [valueRating, setValueRating] = useState(0);
    const marks = [
        { value: 0, label: '0', },
        { value: 1, label: '1', },
        { value: 2, label: '2', },
        { value: 3, label: '3', },
        { value: 4, label: '4', },
        { value: 5, label: '5', },
        { value: 6, label: '6', },
        { value: 7, label: '7', },
        { value: 8, label: '8', },
        { value: 9, label: '9', },
        { value: 10, label: '10', },
    ];

    useEffect(() => {
        setValueRating(value || 0)
    }, [value])

    function handleChange(param) {
        const _value = param.target.value;
        setValueRating(_value);
        onSelect && onSelect(_value)
    }

    return (
        <Container className="horizontal-center">
            <SliderBox
                slots={{
                    thumb: (props) => { return ThumbComponent(props, valueRating) },
                    mark: MarkComponent,
                }}
                step={1}
                min={0}
                max={marks.length - 1}
                valueLabelDisplay="auto"
                marks={marks}
                value={valueRating}
                disabled={disable}
                onChange={handleChange}
            />
        </Container>
    );
}

export default Rating10Component